module.exports = __webpack_public_path__ + "static/1556d685ef041775a2396b278f6f75df.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/features/online.jpg
// module id = 1194
// module chunks = 0